export default {
  primary: "#2f74bf",
  success: "#2ecc70",
  error: "#e74d3e",
  grayShade0: "#dce3eb",
  baseWhite: "#ffffff"
};
